import Vue, { FunctionalComponentOptions, CreateElement, RenderContext } from 'vue';

const componentName = 'wok-mobile-dialog-button';

export default <FunctionalComponentOptions>{
    name: componentName,

    functional: true,

    props: {
        kind: {
            type: String,
            default: 'primary',
            validator: (v: string) => v == '' || /(primary|secondary|danger)/.test(v)
        },
        tooltip: {
            type: String,
            default: undefined
        }
    },

    render: function(h: CreateElement, ctx: RenderContext) {
        return h(
            'button', {
                class: [
                    'wok--dialog__button wok--heading-06',
                    `wok--dialog__button--${ctx.props.kind.toLowerCase()}`, 
                    ctx.data.staticClass
                ],
                attrs: { title: ctx.props.tooltip, ...ctx.data.attrs },
                on: ctx.listeners
            }, [
                ctx.slots().default
            ]
        )
    }
}